import React, { useEffect, useReducer, useState } from 'react'
import SignoInterrocation from '../../../assets/images/modal-question/signo-interrogacion.svg'
import { GAME_CONFIG } from '../../../curv-game/constants/game-constants'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'
import AnswerCard from '../../atoms/answerCard/answerCard'
import Button from '../../atoms/button/button'
import './gameQuestionModal.scss'

const validateTime = (currentTime, interval) => {
  if (currentTime.seconds > 0) {
    return {
      ...currentTime,
      seconds: currentTime.seconds - 1,
    }
  } else if (currentTime.seconds === 0 && currentTime.minutes > 0) {
    return {
      ...currentTime,
      seconds: 59,
      minutes: currentTime.minutes - 1,
    }
  } else {
    clearInterval(interval)
    return {
      seconds: 0,
      minutes: 0,
    }
  }
}

const initialTime = {
  minutes: GAME_CONFIG.ANSWER_TIME.MINUTES,
  seconds: GAME_CONFIG.ANSWER_TIME.SECONDS,
}

const GameQuestionModal = ({ onCloseQuestion, questionInfo }) => {
  const [time, dispatch] = useReducer(validateTime, initialTime)
  const [activeAnswer, setActiveAnswer] = useState(false)
  const [stateAnswer, setStateAnswer] = useState(null)

  useEffect(() => {
    const interval = setInterval(() => dispatch(interval), 1000)
    return () => clearInterval(interval)
  }, [])

  const validateQuestion = () => {
    let isValidQuestion =
      activeAnswer?.correct && (time.minutes != 0 || time.seconds !== 0)
    let answerText = isValidQuestion ? 'correcto' : 'incorrecto'
    setStateAnswer(answerText)
    handleDataLayer(answerText)

    setTimeout(() => {
      onCloseQuestion({ correctAnswer: isValidQuestion })
    }, 2000)
  }

  const handleDataLayer = answerText => {
    pushEventDataLayer(
      'Interacciones - Pop-up preguntas',
      'cur-v-shooter',
      'click juego',
      'aceptar'
    )

    pushEventDataLayer(
      'Interacciones - Pop-up preguntas',
      'cur-v-shooter',
      'click juego',
      answerText
    )
  }

  useEffect(() => {
    if (time.minutes === 0 && time.seconds === 0) {
      validateQuestion()
    }
  }, [time])

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => (document.body.style.overflow = 'initial')
  }, [])

  return (
    <div className="f-questionModal">
      <div className="f-questionModal__container">
        <h1 className="f-questionModal__title">{questionInfo?.question}</h1>

        <img
          className="f-questionModal__icon"
          src={
            stateAnswer === 'correcto'
              ? questionInfo?.imageUrl
              : SignoInterrocation
          }
          alt="icono pregunta"
        />

        <div className="f-questionModal__answers">
          {questionInfo?.answers.map(answer => (
            <AnswerCard
              activeAnswer={activeAnswer}
              answer={answer}
              onClick={() => setActiveAnswer(answer)}
              key={answer.id}
            />
          ))}
        </div>

        <Button
          props={`f-questionModal__button ${
            stateAnswer ? `f-questionModal__button--${stateAnswer}` : ''
          }`}
          title={stateAnswer || 'Aceptar'}
          onClick={() => !stateAnswer && validateQuestion()}
          size="f-small"
          color="f-blue"
        />

        <div className="f-questionModal__timer">
          <span className="f-questionModal__timer__text">
            {time.minutes}:{time.seconds?.toString().padStart(2, '0')}
          </span>
        </div>
      </div>
    </div>
  )
}

export default GameQuestionModal
